/**
 * @Author: Florian Merel <florian>
 * @Date:   16-Dec-2020
 * @Email:  florian.merel@prokov.com
 * @Project: ComEditServer
 * @Filename: activity.js
 * @Last modified by:   florian
 * @Last modified time: 22-Sep-2021
 */

import axios from "axios";
import server from "../server.js";
import servicesError from "../ServicesError.js";

const state = {
  loading: false,
  error: {},
  data: null,
};

const getters = {
  getData(context) {
    return context.data;
  },
};

const mutations = {
  setResponse(context, data) {
    context.error = null;
    context.data = data;
  },

  setError(context, error) {
    context.data = null;
    context.error = error;
  },

  setLoading(context, loading) {
    context.loading = loading;
  },

  setData(context, data) {
    context.data = data;
  },
};

const actions = {
  getSyncAck(context) {
    return new Promise((resolve, reject) => {
      context.commit("setLoading", true);
      axios({
        method: "GET",
        url: server.url + server.urls.syncAck + "/",
        headers: server.getHeader(),
      })
        .then((response) => {
          context.commit("setData", response.data);
          context.commit("setLoading", false);
          resolve(response);
        })
        .catch((error) => {
          context.commit("setLoading", false);
          reject(error.response);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
